// src/utils/hsnSummary.js

export const HSN_LIST = ["24022090", "24022050", "24022040", "24022030"];

export function buildHsnSummary(items, skuMaster) {
  const summary = {};
  const activeHsns = new Set(HSN_LIST);

  // 1. DISCOVER ALL HSNs PRESENT IN THIS ORDER
  Object.keys(items || {}).forEach(sku => {
    const s = skuMaster[sku];
    if (s && (s.HSN || s.hsn)) {
      activeHsns.add(String(s.HSN || s.hsn).trim());
    }
  });

  // 2. INITIALIZE SUMMARY ROWS (Defaults + Discovered)
  activeHsns.forEach(hsn => {
    // Find first SKU with this HSN to get its Category/Description
    const sampleSku = Object.values(skuMaster || {}).find(s => String(s.HSN || s.hsn).trim() === hsn);
    
    summary[hsn] = {
      description: sampleSku?.Category || "CIGARETTES",
      qty: 0,
      basic: 0,
      gstAmt: 0,
      cessAmt: 0,
      addlAmt: 0,
      total: 0,
    };
  });

  // 3. CALCULATE VALUES
  Object.keys(items || {}).forEach(sku => {
    const qty = Number(items[sku] || 0);
    if (qty === 0) return;

    const s = skuMaster[sku];
    if (!s) return;

    const hsn = String(s.HSN || s.hsn || "").trim();
    if (!hsn) return;

    const rate = Number(s.Basic_Eway || s.rate || 0);
    const gst = Number(s.gst || 0);
    const cess = Number(s.cess || 0);
    const addl = Number(s.addlcess || 0);

    const BASIC = qty * rate;
    const mrpTotal = qty * (Number(s.mrp) || 0);
    const GST = mrpTotal - (mrpTotal / (1 + (gst / 100)));
    const CESS = BASIC * (cess / 100);
    const ADDL = qty * addl;

    const row = summary[hsn];
    if (row) {
      row.qty += qty;
      row.basic += BASIC;
      row.gstAmt += GST;
      row.cessAmt += CESS;
      row.addlAmt += ADDL;
      row.total += BASIC + GST + CESS + ADDL;
    }
  });

  return summary;
}
